var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadar3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 121,
    viewBox: "0 0 127 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.506 62.708C123.491 94.535 97.3012 120.119 65.2322 120.119C32.5212 120.119 5.90924 93.507 5.90924 60.797C5.90924 28.727 31.4922 2.537 63.3212 1.522C63.5232 0.651003 64.2992 0 65.2322 0C98.7562 0 126.028 27.273 126.028 60.797C126.028 61.729 125.378 62.506 124.506 62.708ZM122.097 60.797C122.097 29.441 96.5872 3.92999 65.2322 3.92999C64.3342 3.92999 63.5872 3.325 63.3512 2.504C32.0522 3.503 6.89124 29.259 6.89124 60.797C6.89124 92.966 33.0642 119.136 65.2322 119.136C96.7702 119.136 122.525 93.978 123.524 62.678C122.702 62.443 122.097 61.694 122.097 60.797ZM65.2322 74.779C57.5202 74.779 51.2482 68.507 51.2482 60.797C51.2482 53.087 57.5202 46.813 65.2322 46.813C72.9432 46.813 79.2152 53.087 79.2152 60.797C79.2152 68.507 72.9432 74.779 65.2322 74.779ZM65.2322 48.779C58.6052 48.779 53.2132 54.17 53.2132 60.797C53.2132 67.423 58.6052 72.814 65.2322 72.814C71.8582 72.814 77.2492 67.423 77.2492 60.797C77.2492 54.17 71.8582 48.779 65.2322 48.779Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2998 61.5389C16.2998 33.7209 38.8498 11.1709 66.6678 11.1709V61.5389H16.2998Z",
    fill: "#2E18EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0.299805,
    y: -0.829102,
    width: 82.368,
    height: 82.3682,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0999163 0 0 0 0 0.0302041 0 0 0 0 0.721517 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar3);
export default __webpack_public_path__ + "static/media/radar3.9d230f61ef604f2ccc7ffa5b627a9f60.svg";
export { ForwardRef as ReactComponent };